module.exports = __webpack_public_path__ + "static/img/empty.ac88c57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/empty.svg
// module id = WmiU
// module chunks = 1